export const breakpoints = {
  tablet: "768px",
  desktop: "1250px"
}